{
  "dropzoneLabel": "Místo pro přetažení",
  "selectPlaceholder": "Vyberte položku",
  "tableResizer": "Změna velikosti",
  "colorSwatchPicker": "Color swatches"
}
